module.exports = __webpack_public_path__ + "img/lock.5371a84c.svg";